import React from 'react'
import { Skeleton } from '@/components/ui/skeleton'

const PhotosPageSkeleton: React.FC = () => (
  <div className="grid grid-cols-[260px_1fr] gap-4">
    <div className="space-y-2">
      <Skeleton className="h-8 w-full" />
      <Skeleton className="h-6 w-5/6" />
      <Skeleton className="h-6 w-4/6" />
      <Skeleton className="h-6 w-5/6" />
    </div>
    <div className="space-y-4">
      <Skeleton className="h-8 w-full" />
      <div className="grid grid-cols-4 gap-2">
        {Array.from({ length: 8 }).map((_, i) => (
          <Skeleton key={i} className="aspect-square w-full" />
        ))}
      </div>
    </div>
  </div>
)

export default PhotosPageSkeleton
